import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import BreadCrumb from "./BreadCrumb/BreadCrumb";
import NewsAPI from "../../../api/NewsApi";
import Victor from "assets/Vectorzz.svg";
import { useTranslation } from "react-i18next";



const ServiceDetails = () => {
  const { t } = useTranslation("Services");
  const { id } = useParams(); 
  const [statsData, setStatsData] = useState(null); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchStatsData = async () => {
      try {
        setLoading(true);
        const response = await NewsAPI.getServiceDetailsData(id);
        setStatsData(response.data); 
      } catch (err) {
        console.error(err);
        setError("حدث خطأ أثناء تحميل البيانات.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchStatsData(); 
    }
  }, [id]);

  if (loading) {
    return <p>جاري تحميل البيانات...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!statsData) {
    return <p>لا توجد بيانات لعرضها.</p>;
  }


  return (
    <>
       <HelmetInfo titlePage={"تفاصيل الخدمة"} />
<div className="mt-[150px]"/>
       <div className="main-container bg-[#fff] mx-auto px-4 py-8 min-h-[1000px]">
      {/* Header Section */}
      <div className="flex flex-col items-center gap-12 max-w-screen-lg mx-auto pb-5">
        {/* Breadcrumb */}
      <BreadCrumb/>

        {/* Title Section */}
        <div className="text-center flex flex-col gap-6">
          {/* <span className="text-lg   text-[#0d6b70]"> {statsData.type?.name}</span> */}
          <h1
          className="text-4xl max-sm:text-[1.25rem] text_bold_Bukra text-[#0d6b70] leading-[80px]">
            {statsData[0]?.name}
          </h1>
          <p
          className="text-lg lg:text-[1.08rem] text_small_Bukra  text-[#667680] leading-relaxed lg:px-[3.75rem]">
               {statsData[0]?.description}
          </p>
        </div>
      </div>

<div className=" lg:w-[77%]  relative mx-auto scale-[98%]  mt-16">
  <div className="self-stretch rtl:text-right justify-start text-[#1d1d1d] text-2xl font-semibold 29LT_Bukra">{statsData[0]?.sections[0]?.title} </div>
  <div className="self-stretch flex justify-center items-center gap-4 max-sm:flex-col mt-6">

    

   

<div className="flex flex-col gap-4">
  {statsData[0]?.sections[0]?.Posts?.length > 0 &&
    statsData[0].sections[0].Posts
    .slice(1)
      .reduce((acc, curr, idx, arr) => {
        if (idx % 2 === 0) {
          acc.push(arr.slice(idx, idx + 2));
        }
        return acc;
      }, [])
      .map((pair, i) => (
        <div key={i} className="flex gap-4 max-sm:flex-col">
          {pair.map((item, idx) => (
            <div
              
              key={item.id}
              className="lg:w-[564px] inline-flex flex-col justify-start items-start gap-4"
            >
              <div className="self-stretch h-16 px-6 py-[18px] bg-[#e5f2e8] rounded-2xl flex flex-row-reverse items-center gap-3">
                <div className="flex-1 rtl:text-right justify-start text-[#1d1d1d] text-base font-medium 29LT_Bukra">
                  {item.title}
                </div>
                <div className="w-2 h-2 bg-[#0d6b70] rounded-md" />
              </div>
            </div>
          ))}
        </div>
      ))}
</div>





  </div>
</div>
   <div className="main-container scale-95 w-[92%] relative mx-auto my-5 p-4 md:py-16 flex justify-center">
        {/* Main Section */}
        <div className="w-full lg:w-[1200px] lg:h-[400px] bg-[#0d6b70] rounded-[32px] flex flex-col lg:flex-row justify-between items-center px-5 lg:py-20 max-sm:py-6 md:px-20 md:py-8">
          {/* Text Section */}
          <div className="flex flex-col gap-5 text-start text-[#fff] lg:w-2/3 px-2">
            <h1 className="text-[24px] md:text-[34px] font-extrabold leading-snug md:tracking-wider animate-section  transition-opacity duration-1000">
            {statsData[0]?.sections[0]?.Posts[0]?.title}
            </h1>
            <p className="text-[14px] text_small_Bukra md:text-[16px] mt-4 leading-relaxed animate-section transition-opacity duration-1000">
              {statsData[0]?.sections[0]?.Posts[0]?.description}
            
            </p>
            <Link
              to={`/formservice/${id}`}
              state={{ name: statsData[0]?.name, type: statsData[0]?.type?.name }}
              className="self-start lg:my-6 max-sm:mt-6 px-10 py-3 bg-white text-[#0d6b70] border border-[#fff] rounded-full hover:bg-white hover:text-[#0d6b70] hover:scale-90 text-[16px] font-medium  animate-section transition-all duration-500 rtl:lg:w-64 ltr:lg:w-80 text-center"
            >
                  {t('ask_service')}
            </Link>
           

          </div>

          {/* Placeholder Image */}
          <div
            className="w-[49%] h-[123%] bg-auto bg-bottom bg-no-repeat rounded-[16px]  animate-section  transition-opacity duration-1000"
            style={{
              backgroundImage: `url(${Victor})`,
            }}
          />
        </div>

  
      </div>
    </div>
    </>
  );

}

export default ServiceDetails
